import React, { Component } from 'react';
import { withRouter } from 'react-router';

import CustomSurveyQuestionApi from 'apis/questions/CustomSurveyQuestion';
import SurveyTemplateQuestionApi from 'apis/questions/CategoryQuestion';
import QuestionForm from 'components/questions/form/questionForm';

class EditQuestion extends Component {
  constructor() {
    super();
    this.state = {
      currentStep: 1,
      inputType: null,
      suggestedQuestions: [],
      inputTypes: [],
      question: {
        answer_attributes: [],
      },
    };
  }

  componentDidMount() {
    this.fetchQuestion();
  }

  isCustomSurveyPage = () => {
    console.log(this.props);
    return this.props.location.pathname.includes('/custom_survey');
  }

  fetchQuestion = () => {
    if (this.isCustomSurveyPage()) return this.fetchCustomSurveyQuestion();
    return this.fetchSurveyTemplateQuestion();
  };

  questionFetchSuccess = questionObj => {
    const {
      question,
      answers,
      input_type: inputType,
      survey_template_question_id,
    } = questionObj;
    const newQuestion = {
      question,
      answer_attributes: answers.map(answer => ({
        ...answer,
        editAnswer: answer.answer,
      })),
      survey_template_question_id,
    };

    this.setState({
      inputType: inputType,
      question: newQuestion,
      currentStep: 1,
      suggestedQuestions: [],
    });
  };

  fetchCustomSurveyQuestion = async () => {
    const { editingQuestionId } = this.props;
    try {
      const { data: questionObj } = await CustomSurveyQuestionApi.getDetails(
        editingQuestionId
      );
      this.questionFetchSuccess(questionObj);
    } catch (e) {
      console.log(e);
    }
  };

  fetchSurveyTemplateQuestion = async () => {
    const { editingQuestionId } = this.props;
    try {
      const { data: questionObj } = await SurveyTemplateQuestionApi.getDetails(
        editingQuestionId
      );
      this.questionFetchSuccess(questionObj);
    } catch (e) {
      console.log(e);
    }
  };

  handleSubmit = values => {
    const { inputType } = this.state;
    const { confirmEdit } = this.props;
    const { question, answer_attributes, survey_template_question_id } = values;
    const answerAttributes = answer_attributes.map(answer => {
      delete answer.editAnswer;
      delete answer.edit;
      return answer;
    });

    const questionObj = {
      answer_attributes: answerAttributes,
      question,
      survey_template_question_id,
      input_type_id: inputType.id,
    };

    confirmEdit(questionObj);
  };

  setInputType = value => {
    const { inputType, question } = this.state;
    if (value && inputType !== value) {
      return this.setState({
        inputType: value,
        question: {
          ...question,
          answer_attributes: [],
        },
      });
    }

    this.setState({ inputType: value });
  };

  render() {
    const { editingQuestionId, toggleForm } = this.props;
    const {
      inputType,
      currentStep,
      suggestedQuestions,
      question,
      inputTypes,
    } = this.state;

    if (!editingQuestionId) return null;

    return (
      <QuestionForm
        inputType={inputType}
        question={question}
        currentStep={currentStep}
        toggleForm={toggleForm}
        suggestedQuestions={suggestedQuestions}
        inputTypes={inputTypes}
        handleSubmit={this.handleSubmit}
        handleNext={this.handleSubmit}
        setInputType={this.setInputType}
        editForm
      />
    );
  }
}

export default withRouter(EditQuestion);



// WEBPACK FOOTER //
// ./src/components/questions/modify/editQuestion.js